import axios from "axios";
import React from 'react';

export const GetBoatData = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/boat/all`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true",
        }
      }
    )
    // console.log("BoatData : ",response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw new Error(error)
  }
}

export const getBoatDataActive = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/boat/all/active`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true",
        }
      })
    // console.log("BoatData : ",response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw new Error(error)
  }
}

export const getSummaryBoatData = async (token) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/boat/summary`
      , {
        headers: {
          'Authorization': `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true",

        }
      }
    )
    // console.log("BoatData : ",response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw new Error(error)
  }
}

export const getboatdataById = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/boat/info/${id}`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true",
        }
      }
    )
    // console.log("BoatData : ",response.data)
    return response.data[0]
  } catch (error) {
    console.error('Error fetching data:', error)
    throw new Error(error)
  }
}

export const GetBoatDataForSelection = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/boat/all/active`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true",
        }
      }
    )
    let data = response.data;
    let tempdata = [];

    for (let i = 0; i < data.length; i++) {
      tempdata.push({
        value: data[i].id,
        label: data[i].name,
      });
    }
    return tempdata;
  } catch (error) {
    console.error('Error fetching data:', error)
    throw new Error(error)
  }
};

export const ChooseBoatTobooking = async (body, token) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_HOST_PATH}/api/booking/chooseboatbyid`, body, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      }
    })
    return response.data
  } catch (error) {
    console.error('Error Update data:', error)
    throw new Error(error)
  }
}

export const GetBoatWork = async (token) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/boat/work`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw new Error(error)
  }
}

export const GetBoatWorkByDateTime = async (body, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST_PATH}/api/test/${body.boatname}/${body.date}/${body.time}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching boat work data:', error);
    throw error; // Throw the error directly, no need to create a new Error object
  }
};

export const CreateBoat = async (body, file, token) => {
  try {
    // console.log('Creating Boat with', file);
    // Create a FormData object to send the file and other data
    const formData = new FormData();

    // Append other fields to FormData
    for (const key in body) {
      formData.append(key, body[key]);
    }

    // If there's a file (indicating an image upload), append it as well
    if (file) {
      formData.append('image', file); // Ensure 'file' is a File object
    }

    const response = await axios.post(
      `${process.env.REACT_APP_HOST_PATH}/api/boat/create`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          "ngrok-skip-browser-warning": "true", // Set the Content-Type to multipart/form-data
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error creating boat:', error);
    throw error; // Throw the error directly
  }
};

export const UpdateBoat = async (body, filename, token) => {
  try {
    // console.log('Updating By', body.id);
    const response = await axios.put(
      `${process.env.REACT_APP_HOST_PATH}/api/boat/update/id/${body.id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating boat:', error);
    throw error; // Throw the error directly, no need to create a new Error object
  }
}

export const ChangedStatus = (id, status, token) => {
  try {
    const response = axios.put(
      `${process.env.REACT_APP_HOST_PATH}/api/boat/update/status/${id}`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error changing boat status:', error);
    throw error; // Throw the error directly, no need to create a new Error object
  }
}


export const searchBoatsWork = async (data, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST_PATH}/api/boat/work/search`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true",
          Authorization: `Bearer ${token}`,
        },
        params: data, // Pass data as params
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch data');
  }
}

export const TestUpdate = async (id,data,token) =>{
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST_PATH}/api/boat/update/test/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch data');
  }
}

export const searchBoat = async (data , token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST_PATH}/api/boat/search`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true",
          Authorization: `Bearer ${token}`,
        },
        params: data, // Pass data as params
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch data');
  }
}